/**
 * Initialized the specific iframe element or iframe child elements if the supplied element is not an iframe
 */
export function initWidenVideos(elem, isElemParent = false) {
    var iframes = (isElemParent) ? elem.querySelectorAll("iframe") : elem;
    iframes.setAttribute("src", "");
    let dataIframeSrc = iframes.getAttribute("data-iframe-src");
    iframes.setAttribute("src", dataIframeSrc);

}

export function resetWidenVideo(iframe) {
    iframe.setAttribute("src", "");
}

/**
 * Forces reload of iframe by resetting its src with the value of its data-src attribute
 * @param {HTMLElement} iframe 
 */
export function reloadWidenVideo(iframe) {
    iframe.setAttribute("src", "");
    let dataSrc = iframe.getAttribute("data-src");
    let dataIframeSrc = iframe.getAttribute("data-iframe-src");
    if(dataSrc) {
      iframe.setAttribute("src", dataSrc);
    } else if (dataIframeSrc) {
      iframe.setAttribute("src", dataIframeSrc)
    }
}